import httpRequest from '@/utils/request';


const getUsersUrl = '/User';
const urlById = (userId: string) => {
  return `/User/${userId}`;
};
const urlForUpdateRole = (userId: string) => {
  return `/User/${userId}/role`;
};
const urlForUpdatePermission = (userId: string) => {
  return `/User/${userId}/permission`;
};
const urlForUpdateTeam = (userId: string) => {
  return `/User/${userId}/team`;
};
const urlForUpdateActive = (userId: string) => {
  return `/User/${userId}/active`;
};
// const getStaffsUrl = '/User/staffs';

export const getUsers = (params: IUser.IRequest.IGetUser = {}): Promise<IUser.IResponse.ISearchData> => {
  return httpRequest.get(getUsersUrl, {
    params,
  });
};
export const addRoles = (params: IUser.IRequest.IUpdateRole): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdateRole(params.userId);
  return httpRequest.post(url, params.roleIds);
};
export const removeRoles = (params: IUser.IRequest.IUpdateRole): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdateRole(params.userId);
  return httpRequest.delete(url, {
    data: params.roleIds,
  });
};
export const addPermissions = (params: IUser.IRequest.IUpdatePermission): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdatePermission(params.userId);
  return httpRequest.post(url, params.permissionIds);
};
export const removePermissions = (params: IUser.IRequest.IUpdatePermission): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdatePermission(params.userId);
  return httpRequest.delete(url, {
    data: params.permissionIds,
  });
};
export const addTeams = (params: IUser.IRequest.IUpdateTeam): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdateTeam(params.userId);
  return httpRequest.post(url, params.teamIds);
};
export const removeTeams = (params: IUser.IRequest.IUpdateTeam): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdateTeam(params.userId);
  return httpRequest.delete(url, {
    data: params.teamIds,
  });
};
export const activeUser = (params: IUser.IRequest.IActiveUser): Promise<IResponseData.IBaseData> => {
  const url = urlForUpdateActive(params.userId);
  return httpRequest.put(url, null, {
    params: {
      active: params.active,
    },
  });
};
export const deleteUser = (userId: string): Promise<IResponseData.IBaseData> => {
  const url = urlById(userId);
  return httpRequest.delete(url);
};

// export const getStaffs = (): Promise<IUser.IResponse.IStaffData> => {
//   return httpRequest.get(getStaffsUrl);
// };
